import styled from 'styled-components';
import { getStatusTextColor, STATUS_COLORS } from '../ProductCard/styles';

export const TABLE_HEADER_HEIGHT = 39;
export const TABLE_MAX_HEIGHT = 730;
export const FIRST_COLUMN_CLASS = 'qa-col-first';
export const LAST_COLUMN_CLASS = 'qa-col-last';

export const Wrapper = styled.div`
    background: ${({ theme }) => theme.colors.componentBackground};
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 12px;
    overflow: hidden;

    .ant-table {
        background: transparent;
    }

    .ant-table-body {
        scrollbar-gutter: stable;
    }

    .ant-table-thead > tr > th.ant-table-cell {
        height: ${TABLE_HEADER_HEIGHT}px;
        padding: 0 6px;
        white-space: nowrap;
        font-size: 11px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.antdTextSecondary};
        text-transform: uppercase;
        letter-spacing: 0.04em;
        background: ${({ theme }) => theme.colors.tableHeaderBackground};
        border-bottom: 1px solid
            ${({ theme }) => theme.colors.antdBorderSecondary};

        &::before {
            display: none;
        }
    }

    .ant-table-tbody > tr > td.ant-table-cell {
        padding: 11px 6px;
        border-bottom: 1px solid
            ${({ theme }) => theme.colors.antdBorderSecondary};
    }

    .ant-table-tbody > tr:last-child > td.ant-table-cell {
        border-bottom: none;
    }

    .ant-table-summary > tr > td.ant-table-cell {
        padding: 0;
        border-bottom: none;
        background: transparent;
    }

    // antd positions every Spin inside the table as its loading overlay
    .ant-table-summary .ant-spin {
        position: static;
        transform: none;
    }

    .ant-table-thead
        > tr
        > th.ant-table-cell.${FIRST_COLUMN_CLASS},
        .ant-table-tbody
        > tr
        > td.ant-table-cell.${FIRST_COLUMN_CLASS} {
        padding-left: 16px;
    }

    .ant-table-thead
        > tr
        > th.ant-table-cell.${LAST_COLUMN_CLASS},
        .ant-table-tbody
        > tr
        > td.ant-table-cell.${LAST_COLUMN_CLASS} {
        padding-right: 16px;
    }
`;

export const ProductCell = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
`;

export const ProductInfo = styled.div`
    min-width: 0;
`;

export const ProductName = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.antdText};
    white-space: nowrap;
`;

export const Ean = styled.div`
    font-size: 11px;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
    font-family: 'SFMono-Regular', Consolas, monospace;
`;

export const CategoryLabel = styled.span`
    display: inline-block;
    max-width: 100%;
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.accentColor};
    background: ${({ theme }) => theme.colors.colorPrimaryBg};
    padding: 2px 8px;
    border-radius: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const MonoValue = styled.div`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.lightFont};
    font-family: 'SFMono-Regular', Consolas, monospace;
`;

export const Value = styled.div<{ danger?: boolean; strong?: boolean }>`
    font-size: 14px;
    font-weight: ${({ strong }) => (strong ? 700 : 400)};
    color: ${({ danger, theme }) =>
        danger ? theme.colors.fail : theme.colors.antdText};
`;

export const AppPriceValue = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.accentColor};
`;

export const DueDateValue = styled.div<{ level?: 'danger' | 'warning' }>`
    font-size: 14px;
    font-weight: 600;
    color: ${({ level, theme }) => {
        if (level === 'danger') return theme.colors.fail;
        if (level === 'warning') return theme.colors.colorWarning;
        return theme.colors.antdText;
    }};
`;

export const StatusBadge = styled.span<{
    level: 'success' | 'warning' | 'danger';
}>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
    background: ${({ level }) => STATUS_COLORS[level].bg};
    color: ${({ level, theme }) => getStatusTextColor(level, theme)};

    &::before {
        content: '';
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: ${({ level }) => STATUS_COLORS[level].dot};
    }
`;

export const EditButton = styled.button`
    background: ${({ theme }) => theme.colors.componentBackground};
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    color: ${({ theme }) => theme.colors.accentColor};
    font-size: 12px;
    font-weight: 700;
    border-radius: 6px;
    height: 30px;
    padding: 0 12px;
    cursor: pointer;

    &:hover {
        border-color: ${({ theme }) => theme.colors.secondaryColor};
    }
`;
